import React from 'react';
import { Table, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { ProductRow } from '../../../services/pw1313Api';

interface ResultTableProps {
  data: ProductRow[];
  loading: boolean;
  queried: boolean;
  noData: boolean;
}

const ResultTable: React.FC<ResultTableProps> = ({ data, loading, queried, noData }) => {
  const columns: ColumnsType<ProductRow> = [
    { title: '品號前段', dataIndex: 'code_front', key: 'code_front', width: 100 },
    { title: '品號後段', dataIndex: 'code_back', key: 'code_back', width: 100 },
    { title: '完整品號', dataIndex: 'full_code', key: 'full_code', width: 150 },
    { title: '類型', dataIndex: 'category', key: 'category', width: 60, align: 'center' as const },
    { title: '規格', dataIndex: 'spec', key: 'spec', ellipsis: true },
  ];

  if (!queried) return null;
  if (noData) return <Empty description="查無此資料" style={{ marginTop: 40 }} />;

  return (
    <Table<ProductRow>
      columns={columns}
      dataSource={data}
      rowKey="full_code"
      loading={loading}
      size="small"
      pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
      scroll={{ x: 600 }}
    />
  );
};

export default ResultTable;
